export const getCookiesByPrefix = (prefix: string): Record<string, string> => {
  if (typeof document === 'undefined') return {}

  return document.cookie.split('; ').reduce((acc: Record<string, string>, cookie) => {
    const separatorIndex = cookie.indexOf('=')
    if (separatorIndex === -1) {
      return acc
    }

    const key = cookie.substring(0, separatorIndex)
    const value = cookie.substring(separatorIndex + 1)

    if (key.startsWith(prefix)) {
      const cleanedKey = key.substring(prefix.length)
      acc[cleanedKey] = decodeURIComponent(value)
    }

    return acc
  }, {})
}
